export const SETTING = {
  List: '/settings',
  Initial: '/settings/initial',
  Update: '/settings/{id}',
  UpdateMany: '/settings',
};
